module.exports = __webpack_public_path__ + "static/media/fig_15b.d6b61598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_15b.jpg
// module id = 645
// module chunks = 0